import { Fragment, useState, useContext, useEffect } from 'react';

import classes from './PassKeyMarket.module.scss';
import timer from '../../../assets/icons/timer.svg';
import arrowLeftWhite from '../../../assets/icons/arrow-left-white.svg';
import arrowRightWhite from '../../../assets/icons/arrow-right-white.svg';
import Modal from '../../General/Static/Modal/Modal';
import PassKeyNamePopup from './PassKeyNamePopup/PassKeyNamePopup';
import PassKeyCompletePopup from './PassKeyCompletePopup/PassKeyCompletePopup';
import bird from '../../../assets/img/bird_right_hand.png';
import LoginContext from '../../../store/login-context';
import Ajax from '../../../Handler/Ajax';
import * as asyncAjax from '../../../Handler/Ajax';
import Toast from '../../Form//Toast';
import Backdrop from '../../General/Static/BackDrop/Backdrop';
import PassKeyExceedingQuotaPopup from './PassKeyExceedingQuotaPopup/PassKeyExceedingQuotaPopup';
import birdPhoneSmile from '../../../assets/img/mobileBirdSmile.png';


declare var _curLang: any;
declare function Translate(key: string): string;

const PassKeyMarket = () => {

    const ctx = useContext(LoginContext);

    const [showModal,setShowModal] = useState(false);
    const [showCompleteModal,setShowCompleteModal] = useState(false);
    const [showExceedingQuotaModal,setShowExceedingQuotaModal] = useState(false);
    const [isDoNotShowChecked,setIsDoNotShowChecked] = useState(true);
    const [serverMessage,setServerMessage] = useState(Translate(''));  
    const [isBackDrop, setIsBackDrop] = useState(false);

    useEffect(() => {
      let pkView = sessionStorage.getItem('showPkBtn');
      if(pkView !== undefined && pkView === 'false'){
        sessionStorage.removeItem('showPkBtn');
        generatePasskey(); 
      }
    },[]);
           
    const handleCheckboxChange = () => {          
      localStorage.setItem('showPkMarket',(!isDoNotShowChecked).toString());  
      setIsDoNotShowChecked(!isDoNotShowChecked);       
    };
    
    const handleEnter = (event) => {
        if (event.charCode === 13 ){
          setIsDoNotShowChecked(!isDoNotShowChecked);
        }
        if (event.charCode === 32){
          setIsDoNotShowChecked(!isDoNotShowChecked);
        }
    };
    
    const showPasskeyNamePopup = () => {
        setShowModal(true);
    };

    const closePopup = () => {
        setShowModal(false);        
    };

    const showPasskeyCompletePopup = () => {
        setShowCompleteModal(true);
    };

    const closeCompletePopup = () => {
        setShowCompleteModal(false);
    };

    const showExceedingQuotaPopup = () => {
      setShowExceedingQuotaModal(true);
    };

    const closeExceedingQuotaPopup = () => {
      setShowExceedingQuotaModal(false);
    };

    const refusePasskey = () => {
          ctx.setSuccess();            
    }

    const generatePasskey = () => {
      setServerMessage('');

      if(!ctx.devMode){
        if (!window.PublicKeyCredential){
          setServerMessage(Translate('N_General_Error_Passkey_Not_Supported'));             
        } 
        else{  
          setIsBackDrop(true);
          asyncAjax.startRegistrationProcess()
            .then((pkCredential: any) => {                            
              Ajax.sendRegistrationRequest(pkCredential)
                  .then(()=>{
                      setIsBackDrop(false);
                      showPasskeyNamePopup();
                  })
                  .catch((error) => {
                    setIsBackDrop(false);
                    setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR')); 
                  })          
            })
            .catch((error) => { 
              setIsBackDrop(false); 
              if(error === 'N_General_Error_USER_CREDENTIALS_NUMBER_REACHED_MAXIMUM_VALUE'){
                showExceedingQuotaPopup();
              }            
              else if(error !== 'cancel'){
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR')); 
              }   
            });
        }
      }
      else{
        setIsBackDrop(true);
        asyncAjax.startRegistrationProcessDemo()
          .then((pkCredential: any) => {                               
            Ajax.sendRegistrationRequestDemo(pkCredential)
                .then(()=>{
                    setIsBackDrop(false);
                    showPasskeyNamePopup();
                })
                .catch((error) => {
                  setIsBackDrop(false);
                    console.log(error);
                })          
          })
          .catch((error) => {
            setIsBackDrop(false);
            if(error !== 'cancel'){
              setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR')); 
            }                       
          });
      }                                
    }
    
    const onSaveNameHandler = (nickName: string) => {      
      if(!ctx.devMode){
        Ajax.setAuthenticatorNickname(nickName)
          .then((pkCredential: any) => {
            closePopup();
            showPasskeyCompletePopup();
          })
          .catch((error) => {
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));        
          }); 
      } 
      else{
        Ajax.setAuthenticatorNicknameDemo(nickName)
          .then((pkCredential: any) => {
            closePopup();
            showPasskeyCompletePopup();
          })
          .catch((error) => {
            console.log(error);          
          }); 
      }    
    };

    const onContinueHandler = () => {
      ctx.setSuccess();
    };

    return (
        <Fragment>
            {isBackDrop &&
              <Backdrop />
            }

            {showModal &&
                <Modal >
                    <PassKeyNamePopup close={closePopup}  saveName={onSaveNameHandler}/>
                </Modal>
            }

            {showCompleteModal && 
                <Modal>
                    <PassKeyCompletePopup close={closeCompletePopup} Continue={onContinueHandler}/>
                </Modal>
            }

            {showExceedingQuotaModal &&
              <Modal>
                  <PassKeyExceedingQuotaPopup close={closeExceedingQuotaPopup} Continue={onContinueHandler}/>
              </Modal>
            }

            <div className={classes.pkm_container_wrapper}>
              <div className={classes.pkm_container}>
                  {/* <div className={classes.pkm_hello_container}>
                      <span className={classes.pkm_hello}>בוקר טוב,</span>
                      <span className={classes.pkm_hello_bold}>ישראל ישראלי</span>
                  </div> */}
                  <div className={classes.pkm_title}>
                      <span>{Translate('N_Login_Pk_Market_Title')}</span>
                  </div>
                  <div className={classes.pkm_sub_title}>
                      <span>{Translate('N_Login_Pk_Market_Desc')}</span>
                  </div>
                  <div className={classes.pkm_time_container}>
                      <img src={timer} alt='' className={classes.pkm_time_img} aria-hidden="true"/>
                      <span>
                          <span >
                            {Translate('N_Login_Pk_Market_Time_1')}
                          </span>
                          <span className={classes.pkm_time_desc_bold}>
                            {Translate('N_Login_Pk_Market_Time_2')}
                          </span>
                      </span>
                  </div>
                  {serverMessage.length > 0 && (
                    <div className='mt-2'>
                      <Toast message={serverMessage} />
                    </div>
                  )}
                  <div className={classes.pkm_button_container}>
                      <button className={classes.pkm_button} id='generatePassKeyBtn' onClick={generatePasskey}>
                          <span>{Translate('N_General_Start')}</span>
                          <img alt='' src={(_curLang === 'en' || _curLang === 'ru' ? arrowRightWhite : arrowLeftWhite)} className={classes.pkm_left_arrow} aria-hidden="true"/>
                      </button>
                  </div>                
                  <div className={classes.pkm_refuse_link} role="link" id='refusePasskeyBtn' onClick={refusePasskey}>
                      <span>{Translate('N_General_Not_Right_now')}</span>
                  </div>
                  <div className={classes.pkm_security}>
                    {Translate("N_Login_Pk_Market_Security")}                
                  </div>

                  <div className={classes.pkm_button_container_mobile}>
                      <button className={classes.pkm_button} id='generatePassKeyBtnMobile' onClick={generatePasskey}>
                          <span>{Translate('N_General_Start_Now')}</span>                     
                      </button>
                      <button className={classes.pkm_button_cancel} id='refusePasskeyBtnMobile' onClick={refusePasskey}>
                          <span>{Translate('N_General_Not_Right_now')}</span>                     
                      </button>
                  </div>            
              </div>
              <div className={classes.pkm_Bottom_container}>
                <div className={classes.bird_desktop}>
                  <img src={birdPhoneSmile} alt="bird" />
                </div>
                <div className={classes.do_not_show_container}>
                      <input 
                        type="checkbox" 
                        id="doNotShow" 
                        className={classes.do_not_show_chekbox} 
                        checked={!isDoNotShowChecked}
                        onChange={handleCheckboxChange}
                        onKeyPress={handleEnter} 
                      ></input>
                      <label htmlFor='doNotShow'>{Translate('N_General_Do_Not_Show_Again')}</label>
                </div> 
                <div className={classes.bird_mobile}>
                    <img src={bird} alt="" aria-hidden="true"/>
                </div> 
              </div>
            </div>     
        </Fragment>
    )
};
export default PassKeyMarket;
